import { Box, HStack, VStack, Text, Icon, Button } from '@chakra-ui/react';
import { FaCoins, FaBolt } from 'react-icons/fa';
import { useCreditPackCard } from './useCreditPackCard'

export const CreditPackCard = ({ credits, price }) => {

  const {
    loading,
    buyCredits
  } = useCreditPackCard();

  return (
    <Box
      border="1px solid"
      borderColor="gray.200"
      borderRadius="2xl"
      p={6}
      bg="white"
      shadow="sm"
      _hover={{ shadow: 'lg' }}
      transition="box-shadow 0.2s"
      w="full"
    >
      <HStack
        justify="space-between"
        align="center"
        flexWrap={{ base: 'wrap', md: 'nowrap' }}
        spacing={4}
      >
        <HStack spacing={2}>
          <Icon as={FaCoins} color="orange.400" boxSize={6} />
          <Text fontSize="2xl" fontWeight="bold" color="blue.700">
            {credits}
          </Text>
          <Text fontSize="sm" color="gray.500">
            Credits
          </Text>
        </HStack>

        <VStack spacing={0} align="start">
          <Text fontSize="2xl" fontWeight="semibold" color="blue.700">
            {price}
          </Text>
          <Text fontSize="xs" color="gray.400">
            No Expiry
          </Text>
        </VStack>

        <Button
          colorScheme="blue"
          leftIcon={<FaBolt />}
          px={5}
          py={2}
          flexShrink={0}
          isLoading={loading}
          onClick={() => buyCredits(credits)}
        >
          Buy
        </Button>
      </HStack>
    </Box>
  );
};